import { fetchWithCache, getCachedData } from "../services/apiService";

export const propertyByIds = async ({ setProperty }, setModal, property_id) => {
  const cacheKey = `/api/property/propertyById_${property_id}`;

  // Show cached data immediately if available
  const cached = getCachedData(cacheKey, {});
  if (cached) {
    setProperty(cached[0]);
    setModal(true);
    return;
  }

  try {
    const data = await fetchWithCache(
      "/api/property/propertyById",
      {
        method: "POST",
        body: JSON.stringify({ id: property_id }),
        cacheKey,
        retries: 2,
        timeout: 10000,
      },
      true,
    );

    setProperty(data[0]);
    setModal(true);
  } catch (error) {
    if (!cached) {
      setModal(false);
    }
  }
};
